import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Direction, DirectionRequest, DirectionsModel } from '../../shared/models/directions/directions';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class DirectionsService {
  private directionsCache: Direction[] | null = null;
  private directionDetailCache: { [key: string]: DirectionsModel } = {};

  constructor(private httpClient: HttpClient) { }
  private directionApiBaseUrl = 'api/Direction';

  getAllDirections(): Observable<Direction[]> {
    if (this.directionsCache) {
      return of(this.directionsCache);
    } else {
      return this.httpClient.get<Direction[]>(this.directionApiBaseUrl + '/All').pipe(
        tap(directions => this.directionsCache = directions)
      );
    }
  }

  getDirectionDetail(directionRequest: DirectionRequest): Observable<DirectionsModel> {
    const cacheKey = JSON.stringify(directionRequest);
    if (this.directionDetailCache[cacheKey]) {
      return of(this.directionDetailCache[cacheKey]);
    } else {
      return this.httpClient.post<DirectionsModel>(this.directionApiBaseUrl, directionRequest).pipe(
        tap(detail => this.directionDetailCache[cacheKey] = detail)
      );
    }
  }

  clearCache() {
    this.directionsCache = null;
    this.directionDetailCache = {};
  }
}
